// extracted by mini-css-extract-plugin
module.exports = {"primary":"#02aab0","secondary":"#00cdac","white":"#fff","darkgrey":"#333","darkbluetext":"#272341"};